export default "__VITE_ASSET__Hh69qxiT__"